import { forwardRef } from "react";
import { styled } from "@mui/material/styles";
import { Button, Box } from "@mui/material";
import Typography from "@mui/material/Typography";
import Slider from "@mui/material/Slider";
import { useTranslation } from "react-i18next";
import { useMediaQuery } from "@mui/material";
import { withStyles } from "@material-ui/core/styles";

const Separator = styled("div")(
  ({ theme }) => `
  height: ${theme.spacing(3)};
`
);

function valuetext(value) {
  return `${value}`;
}

const CustomSlider = withStyles({
  markLabel: {
    fontSize: "9px",
  },
})(Slider);

const LinearSliderQuestion = forwardRef(
  (
    {
      data,
      currentQuestion,
      scrollToQuestion,
      show,
      latestQuestion,
      handlePayload,
      value,
      isEdit,
      latestStepQuestion,
    },
    ref
  ) => {
    const nextQuestionHandler = (height) => {
      handlePayload(data, data.key === 'WebApp_Dev_number_F' && value === null ? 1 : value);
      scrollToQuestion(data, height, value);
    };

    const isMobile = useMediaQuery("(max-width:900px)");

    const handleSliderChange = (event, newValue) => {
      handlePayload(data, data.key === 'WebApp_Dev_number_F' && newValue === 0 ? 1 : newValue);
    };
    const { t } = useTranslation();
    return (
      <>
        {show && (
          <div
            style={{ padding: isMobile ? "100px 0px" : "100px 20px" }}
            ref={ref}
          >
            <>
              <Typography variant="subtitle1">{t(data.question)}</Typography>
              <br></br>
              {isMobile ? (
                <Box>
                  <CustomSlider
                    aria-labelledby="track-false-slider"
                    getAriaValueText={valuetext}
                    defaultValue={0}
                    marks={data.marks}
                    step={data.step}
                    valueLabelDisplay={data.valueLabelDisplay}
                    onChange={handleSliderChange}
                    max={data.max}
                    min={data.min}
                    value={value}
                  />
                  <Separator />
                </Box>
              ) : (
                <Box>
                  <Slider
                    aria-labelledby="track-false-slider"
                    getAriaValueText={valuetext}
                    defaultValue={0}
                    marks={data.marks}
                    step={data.step}
                    valueLabelDisplay={data.valueLabelDisplay}
                    onChange={handleSliderChange}
                    max={data.max}
                    min={data.min}
                    value={value}
                  />
                  <Separator />
                </Box>
              )}
              {currentQuestion === data.id &&
              currentQuestion !== latestQuestion &&
              !(isEdit && latestStepQuestion === data.id) ? (
                <>
                  {" "}
                  {/* <br></br> */}
                  <Button
                    onClick={() => {
                      nextQuestionHandler(ref.current.clientHeight);
                    }}
                    // disabled={data.required}
                    style={{ height: "50px" }}
                    color="secondary"
                    variant="contained"
                    fullWidth
                    disabled={!value}
                  >
                    {t("next")}
                  </Button>
                </>
              ) : (
                <></>
              )}
            </>
          </div>
        )}
      </>
    );
  }
);

export default LinearSliderQuestion;
